import { Command, ICommandResult } from '@/_core/cqrs/types/commands';

export class InitializeReleaseViewOrder extends Command<InitializeReleaseViewOrderResult> {
    public StorymapId: string;
    public ReleaseId: string;

    constructor(storymapId: string, releaseId: string) {
        super('InitializeReleaseViewOrder');
        this.StorymapId = storymapId;
        this.ReleaseId = releaseId;
    }
}

export interface InitializeReleaseViewOrderResult extends ICommandResult {
    WasInitialized: boolean;
    SubtaskOrders: { [key: string]: number };
}